import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { changeProjectAction } from '@containers/Home/slice';
import {
  DEFAULT_VALUE_TOUR_EVENT_STATS,
  DEFAULT_VALUE_TOUR_STATS,
  useTourEventState,
  useVLookatKrpano,
  useHLookatKrpano,
  useZoomKrpano,
  useTourStats,
} from '@containers/Home/global/TourStats';
import { useCallback, useMemo } from 'react';
import { selectProvinceSelected } from '@containers/App/selectors';

const useNavigateBetweenProject = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const provinceSelected = useSelector(selectProvinceSelected);

  const [, setTourStats] = useTourStats('stats');
  const [tourEventStats, setTourEventStats] = useTourEventState('state');
  const [, setZoomKrpano] = useZoomKrpano('zoom');
  const [, setlLookatKrpano] = useHLookatKrpano('hlookat');
  const [, setVlookatKrpano] = useVLookatKrpano('vlookat');

  const onChangeProject = useCallback(
    (slug = '') => {
      setTourEventStats({
        ...DEFAULT_VALUE_TOUR_EVENT_STATS,
        isSoundOnScene: tourEventStats.isSoundOnScene,
        isLoaded: tourEventStats.isLoaded,
      });
      setTourEventStats({
        ...DEFAULT_VALUE_TOUR_EVENT_STATS,
        isSoundOnScene: tourEventStats.isSoundOnScene,
        isLoaded: tourEventStats.isLoaded,
      });
      setTourStats(DEFAULT_VALUE_TOUR_STATS);
      setlLookatKrpano(undefined);
      setVlookatKrpano(undefined);
      setZoomKrpano(undefined);
      if (slug) {
        router.push(
          `${process.env.NEXT_PUBLIC_BASE_URL_PUBLIC}/${provinceSelected}/discover/${slug}`,
          undefined,
          { shallow: true },
        );
        dispatch(changeProjectAction({ slug }));
      }
    },
    [
      router,
      dispatch,
      setTourStats,
      setZoomKrpano,
      tourEventStats,
      provinceSelected,
      setlLookatKrpano,
      setVlookatKrpano,
      setTourEventStats,
    ],
  );

  return useMemo(
    () => ({
      onChangeProject,
    }),
    [onChangeProject],
  );
};

export default useNavigateBetweenProject;
